import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MarketConfigurable } from '@core/domain/impl/market-configurable.impl';
import { getCountryCode } from '@core/infrastructure/state/core.selectors';
import { GoToSection } from '@shared/navigation/store/navigation.actions';

// TODO ECOMDUTI-21025 [TechDebt][Comercial] - Este servicio no debería estar en root
@Injectable({
    providedIn: 'root',
})
export class MarketService extends MarketConfigurable<Record<string, any>> {
    /*
        * For China law is not convenient to let the users to change the country.
    */
    protected readonly config: Record<string, Record<string, any>> = {
        CN: {
            canChangeCountry: false,
        },
        default: {
            canChangeCountry: true,
        },
    };

    public canChangeCountry$: Observable<boolean> = this.store.select(getCountryCode).pipe(
        map((countryCode) => this.getConfigByMarketCode(countryCode).canChangeCountry)
    );

    constructor(
        private readonly store: Store,
    ) {
        super();
    }

    public gotToWW(): void {
        this.store.dispatch(GoToSection({ url: 'worldwide' }));
    }
}
